import { Dispatch } from "redux"
import { CampaignsAction, CampaignsActionTypes } from "../types/campaigns"
import projectApi from "../../api-wrapper/project/project"

const fetchCampaignsList = () => {
  return async (dispatch: Dispatch<CampaignsAction>) => {
    try {
      dispatch({
        type: CampaignsActionTypes.FETCH_CAMPAIGNS_LIST,
      })
      const campaigns = await projectApi.getCampaignsList()
      dispatch({
        type: CampaignsActionTypes.FETCH_CAMPAIGNS_LIST_SUCCESS,
        payload: campaigns,
      })
    } catch (e) {
      dispatch({
        type: CampaignsActionTypes.FETCH_CAMPAIGNS_LIST_ERROR,
        payload: "Default orders load error",
      })
    }
  }
}

const campaignsActions = {
  fetchCampaignsList,
}

export default campaignsActions
